var _path, _ellipse, _circle, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordShow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.40362C24 9.40362 18.6274 15.6258 12 15.6258C5.37258 15.6258 0 9.40362 0 9.40362C0 9.40362 5.37258 3.1814 12 3.1814C18.6274 3.1814 24 9.40362 24 9.40362Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0002,
    cy: 8.9592,
    rx: 4.88889,
    ry: 4.88889,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 8.95901,
    r: 3.11111,
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.55566,
    y: 2.40039,
    width: 2.66667,
    height: 21.3333,
    rx: 1.33333,
    transform: "rotate(-45 3.55566 2.40039)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44434 1.47221C4.90531 1.33272 5.85774 1.03917 6.22211 1.40354L19.5811 14.7625C19.9454 15.1268 19.6263 16.1129 19.4869 16.5739C19.6927 16.5116 19.8865 16.3992 20.0491 16.2366C20.5761 15.7096 20.5761 14.7959 20.0491 14.2689L6.69012 0.909896C6.16313 0.382899 5.3087 0.382899 4.7817 0.909896C4.61904 1.07256 4.50658 1.26642 4.44434 1.47221Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/password-show.d2450153df2ed3c810a882a37a3b717a.svg";
export { ForwardRef as ReactComponent };